import styled from 'styled-components';

export const Main = styled.main`
	padding: 25px 0;
`;
